const posts = [];

export default posts;
